export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 px-4 md:px-6 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <p className="text-teal-600 text-xs md:text-sm font-semibold uppercase tracking-wider mb-2 md:mb-3">
            About Us
          </p>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
            회사소개
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
            <span className="hidden md:block">30년의 전문성과 실증된 성공 경험으로 U&I가 여러분의 성장을 설계합니다</span>
            <span className="md:hidden">30년 전문성으로 여러분의 성장을 설계합니다</span>
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center mb-12 md:mb-20">
          <div>
            <div 
              className="rounded-xl md:rounded-2xl overflow-hidden shadow-xl md:shadow-2xl"
              style={{ width: '100%', height: '350px' }}
            >
              <img
                src="https://public.readdy.ai/ai/img_res/b9917ae6d6262aa69e4727f99f51f70b.jpg"
                alt="이광철 대표이사"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="space-y-4 md:space-y-6">
            <div className="inline-block px-3 py-1.5 md:px-4 md:py-2 bg-teal-100 rounded-lg">
              <span className="text-teal-700 font-semibold text-sm md:text-base">CEO 인사말</span>
            </div>
            
            <h3 className="text-xl md:text-3xl font-bold text-gray-900 leading-snug">
              <span className="hidden md:block">
                단순한 인증 취득을 넘어<br />기업의 생존과 성장을 위한<br />실전형 전략을 제시합니다
              </span>
              <span className="md:hidden">
                인증 취득을 넘어<br />실전형 성장 전략을 제시합니다
              </span>
            </h3>
            
            <p className="text-sm md:text-lg text-gray-700 leading-relaxed">
              <span className="hidden md:block">
                30년 현장 노하우를 가진 이광철 대표와 각 분야 전문가들이 귀사의 가치를 대외적으로 증명하는 전략적 파트너가 되겠습니다.
              </span>
              <span className="md:hidden">
                30년 현장 노하우로 귀사의 가치를 증명하는 전략적 파트너가 되겠습니다.
              </span>
            </p>

            <div className="bg-white rounded-xl p-5 md:p-8 shadow-lg border border-gray-100">
              <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-4">
                <span className="hidden md:inline">대표이사 프로필: </span>이광철 박사
              </h4>
              
              <div className="space-y-3 md:space-y-4">
                <div>
                  <div className="flex items-start gap-2 md:gap-3">
                    <i className="ri-graduation-cap-line text-teal-600 text-lg md:text-xl mt-0.5"></i>
                    <div>
                      <strong className="text-gray-900 text-sm md:text-base">학력</strong>
                      <p className="text-gray-700 mt-1 text-xs md:text-base">가톨릭대 경영학 박사</p>
                      <p className="text-gray-700 text-xs md:text-base">고려대 기술경영학 석사</p>
                      <p className="text-gray-700 text-xs md:text-base hidden md:block">숭실대학교 경영학부 중소기업학 전공 경영학사</p>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="flex items-start gap-2 md:gap-3">
                    <i className="ri-award-line text-teal-600 text-lg md:text-xl mt-0.5"></i>
                    <div>
                      <strong className="text-gray-900 text-sm md:text-base">자격</strong>
                      <p className="text-gray-700 mt-1 text-xs md:text-base">ISO 국제선임심사원</p>
                      <p className="text-gray-700 text-xs md:text-base">경영지도사 · 국제공인경영컨설턴트(CMC)</p>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="flex items-start gap-2 md:gap-3">
                    <i className="ri-briefcase-line text-teal-600 text-lg md:text-xl mt-0.5"></i>
                    <div>
                      <strong className="text-gray-900 text-sm md:text-base">주요 경력</strong>
                      <p className="text-gray-700 mt-1 text-xs md:text-base">현 가톨릭대/인덕대 겸임교수</p>
                      <p className="text-gray-700 text-xs md:text-base">현 중기부, 산자부 R&D 평가위원</p>
                      <p className="text-gray-700 text-xs md:text-base hidden md:block">현 이노비즈/메인비즈협회 전문위원</p>
                      <p className="text-gray-700 text-xs md:text-base hidden md:block">전 LX판토스(LG그룹) 경영혁신 담당 차장</p>
                    </div>
                  </div>
                </div>

                <div className="hidden md:block">
                  <div className="flex items-start gap-3">
                    <i className="ri-trophy-line text-teal-600 text-xl mt-1"></i>
                    <div>
                      <strong className="text-gray-900">수상</strong>
                      <p className="text-gray-700 mt-1">국토교통부장관 표창 (우수 컨설팅 부문) 외 다수</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-xl md:rounded-2xl p-6 md:p-12 text-white">
          <h3 className="text-xl md:text-3xl font-bold mb-6 md:mb-8 text-center">유엔아이파트너스의 강점</h3>
          
          <div className="grid md:grid-cols-3 gap-4 md:gap-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6">
              <div className="w-10 h-10 md:w-14 md:h-14 bg-white/20 rounded-full flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-file-list-3-line text-xl md:text-3xl"></i>
              </div>
              <h4 className="text-base md:text-xl font-bold mb-2 md:mb-3">
                <span className="hidden md:inline">800여 건 이상의 제조 중심 성공 레퍼런스</span>
                <span className="md:hidden">800+ 성공 레퍼런스</span>
              </h4>
              <p className="text-white/90 leading-relaxed text-xs md:text-base">
                <span className="hidden md:inline">지엠이, 디알씨티에스, SK I&C 등 검증된 실적으로 신뢰를 입증합니다.</span>
                <span className="md:hidden">검증된 실적으로 신뢰를 입증합니다.</span>
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6">
              <div className="w-10 h-10 md:w-14 md:h-14 bg-white/20 rounded-full flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-settings-3-line text-xl md:text-3xl"></i>
              </div>
              <h4 className="text-base md:text-xl font-bold mb-2 md:mb-3">원스톱 솔루션</h4>
              <p className="text-white/90 leading-relaxed text-xs md:text-base">
                <span className="hidden md:inline">ISO부터 정부지원사업, 재무관리까지 기업 생애주기별 맞춤 지원을 제공합니다.</span>
                <span className="md:hidden">ISO부터 정부지원사업까지 맞춤 지원</span>
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6">
              <div className="w-10 h-10 md:w-14 md:h-14 bg-white/20 rounded-full flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-lightbulb-line text-xl md:text-3xl"></i>
              </div>
              <h4 className="text-base md:text-xl font-bold mb-2 md:mb-3">실전형 전략</h4>
              <p className="text-white/90 leading-relaxed text-xs md:text-base">
                <span className="hidden md:inline">단순 이론이 아닌, 정부 부처 평가위원 활동을 통한 '되는' 전략을 제시합니다.</span>
                <span className="md:hidden">정부 평가위원 경험 기반 실전 전략</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
